import React, { Component } from "react";
import { Col } from "reactstrap";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../../ptsAlert/PtsAlert";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import PtsButton from "../../buttons/PtsButton";
import UnitOfMeasurement from "./UnitOfMeasurement";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveButton from "../../buttons/SaveButton";
import CancelIconButton from "../../buttons/CancelIconButton";
import EditIconButton from "../../buttons/EditIconButton";
import DeleteIconButton from "../../buttons/DeleteIconButton";

class UnitOfMeasurementList extends Component {
  header = store.getState().header.header;
  constructor() {
    super();
    this.state = {
      initialPage: 0,
      pageSize: 10,
      uomList: [],
      render: false,
      getCreatePermission: false,
      getUpdatePermission: false,
      getDeletePermission: false,
    };
    this.getUomList();
  }
  getUomList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService("/uomms/getList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let uomList = output.data.uomList;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let isPaging = false;
          if (uomList.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            render: true,
            uomList: uomList,
            isPaging: isPaging,
            initialPage: this.state.initialPage,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } 
      }
    );
  }

  createUomToBackend() {
    const postObject = {
      header: this.header,
      uom: {
        name: this.state.name,
        abbrevition: this.state.abbrevition,
        measuretype: this.state.measuretype,
      },
    };
    FetchServerData.callPostService("/uomms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let uomInfo = output.data.uom;
          this.setState({
            render: true,
            uomOpen: false,
            action: "view",
            uomList: [uomInfo, ...this.state.uomList],
          });
        } 
      }
    );
  }

  updateUomToBackend() {
    const postObject = {
      header: this.header,
      uom: {
        id: this.state.id,
        name: this.state.name,
        abbrevition: this.state.abbrevition,
        measuretype: this.state.measuretype,
      },
    };
    FetchServerData.callPostService("/uomms/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let uomData = output.data.uom;
          var currentIndex = this.state.uomList.findIndex(
            (d) => d.id === uomData.id
          );
          let currentList = [...this.state.uomList];
          currentList.splice(currentIndex, 1, uomData);
          this.setState({
            render: true,
            uomList: currentList,
            uomOpen: false,
          });
        } 
      }
    );
  }
  deleteUomToBackend = (uomId) => {
    console.log(uomId);
    const postObject = {
      header: this.header,
      uom: {
        id: uomId,
      },
    };
    FetchServerData.callPostService("/uomms/delete", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          // var newList = output.data.uom;
          for (let i = 0; i < this.state.uomList.length; i++) {
            if (this.state.uomList[i].id === uomId) {
              this.state.uomList.splice(i, 1);
            }
          }
          this.setState({ uomList: this.state.uomList, render: true });
          PtsAlert.success(output.message);
        } 
      }
    );
  };

  addUom() {
    let uomInfos = this.state.uomList;
    let uomInfo = {
      action: "create",
      operation: "add",
      name: "",
      abbrevition: "",
      measuretype: "",
    };
    uomInfos.push(uomInfo);
    this.setState({
      assetCodeList: uomInfos,
      addRow: true,
      action: "create",
    });
  }

  handleAddUomOpen() {
    this.setState({
      uomOpen: true,
      action: "create",
      name: "",
      abbrevition: "",
      measuretype: "",
    });
  }

  handleEditUomOpen(id) {
    const rowData = this.state.uomList.find((item) => item.id === id);
    this.setState({
      uomOpen: true,
      action: "edit",
      id: rowData.id,
      name: rowData.name,
      abbrevition: rowData.abbrevition,
      measuretype: rowData.measuretype,
    });
  }

  handleUOMClose() {
    this.setState({
      uomOpen: false,
    });
  }

  onUomRemove(item) {
    let items = [];
    if (item.operation && "add" === item.operation) {
      /* Added Item Deleted, Remove from list */
      let index = item.srno;
      for (let i = 0; i < this.state.uomList.length; i++) {
        if (this.state.uomList[i].operation === "add" && index === i) {
          this.uomRefList.splice(i, 1);
        } else {
          items.push(this.state.uomList[i]);
        }
      }
      this.setState({ uomList: items, addRow: false });
    }
  }
  onUomEditClick(e) {
    console.log(e);
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value });
  }

  handleAbbrevitionChange(e) {
    this.setState({
      abbrevition: e.target.value,
    });
  }
  handleMeasureTypeChange(e) {
    this.setState({
      measuretype: e.target.value,
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    this.uomRefList = [];
    for (let i = 0; this.state.uomList && i < this.state.uomList.length; i++) {
      this.uomRefList[i] = React.createRef();
    }

    let uomItemList = [];
    this.state.uomList &&
      this.state.uomList.forEach((element, index) => {
        uomItemList.unshift(
          <UnitOfMeasurement
            ref={this.uomRefList[index]}
            key={index}
            data={element}
            backgroundColor={
              index % 2 ? { background: "#EFF4F7" } : { background: "#F7F7F7" }
            }
            srno={index}
            action={element.action ? element.action : "view"}
            // ListRow={this.state.etinListRow}
            iteamIndex={this.state.uomList.length - index}
            onAdd={this.createUomToBackend.bind(this)}
            onUomEditClick={this.onUomEditClick.bind(this)}
            onUomDelete={this.deleteUomToBackend.bind(this)}
            onUomUpdateSave={this.updateUomToBackend.bind(this)}
            onUomRemove={this.onUomRemove.bind(this)}
          />
        );
      });

    return (
      <>
        <div style={{ maxWidth: "100%" }}>
          <div style={{ maxWidth: "100%" }}>
            <div className="row">
              <Col md={12} style={{ flexDirection: "column", display: "flex" }}>
                <div className="card">
                  <div className="row justify-content-between p-3">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="col-12 text-start totalResults">
                        {/* <span>Total Results:</span> */}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        {/* <input
                        type="search"
                        id="gsearch"
                        placeholder="Search"
                        name="gsearch"
                        style={{ marginTop: "2px" }}
                      // value={this.state.searchText}
                      // onChange={this.onSearchChange.bind(this)}
                      />
                      <button
                        className="gsearchButton"
                      // onClick={this.onSearchClick.bind(this)}
                      >
                        <i className="fa fa-search" aria-hidden="true"></i>
                      </button> */}{" "}
                        &nbsp;&nbsp;
                        {/* {this.state.addRow ? */}
                        <PtsButton
                          btnName="Add New Measure"
                          type="submit"
                          // onClick={this.addUom.bind(this)}
                          onClick={this.handleAddUomOpen.bind(this)}
                        />
                        {/* :
                          <Button
                            className="add"
                            style={{
                              background: "rgb(27, 113, 137)",
                              color: "white",
                              fontSize: "x-larger",
                              textTransform: "capitalize",
                              cursor: "pointer",
                              float: "right",
                              margin: "0.2em 0.5em 0.3em 0em",
                            }}
                            startIcon={<AddIcon />}
                          >
                            Add Asset Code
                          </Button>
                        } */}
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive paginationTableThead">
                    <table className="table text-start table-hover">
                      <thead className="paginationTableThead">
                        <tr>
                          <th style={{ width: "5%" }} scope="col fw-bold ">
                            #
                          </th>
                          <th style={{ width: "20%" }} scope="col fw-bold">
                            Name
                          </th>
                          <th style={{ width: "20%" }} scope="col fw-bold">
                            Abbreviation
                          </th>
                          <th style={{ width: "20%" }} scope="col fw-bold">
                            Measure Type
                          </th>
                          <th style={{ width: "20%" }} scope="col fw-bold">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.uomList?.map((rowData, index) => (
                          <tr className="hoverTable" key={index}>
                            <td style={{ width: "5%" }}>{index + 1}</td>
                            <td style={{ width: "15%" }}>{rowData.name}</td>
                            <td style={{ width: "15%" }}>
                              {rowData.abbrevition}
                            </td>
                            <td style={{ width: "15%" }}>
                              {rowData.measuretype}
                            </td>
                            <td style={{ width: "15%" }} key={rowData.id}>
                              <DeleteIconButton
                                pageId="UnitOfMeasurement"
                                onClick={() =>
                                  this.deleteUomToBackend(rowData.id)
                                }
                                title="measure"
                                domainObject={rowData.namecode}
                              />
                              <EditIconButton
                                onClick={() =>
                                  this.handleEditUomOpen(rowData.id)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {this.state.totalRecords === 0 && (
                    <div className="row text-center p-2">
                      <h5>Data not Available</h5>
                    </div>
                  )}
                </div>
              </Col>
            </div>
          </div>
        </div>
        <Dialog
          open={this.state.uomOpen}
          onClose={this.handleUOMClose.bind(this)}
          maxWidth="xl"
          className="assetCodeDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              {this.state.action === "create"
                ? `Add New Measure`
                : `Edit Measure`}
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleUOMClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={
              this.state.action === "create"
                ? this.createUomToBackend.bind(this)
                : this.updateUomToBackend.bind(this)
            }
          >
            <DialogContent className="pb-2">
              <div className="row ps-4 pe-4">
                <div className="col-sm-12">
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        Name
                      </label>
                      <TextField
                        type="text"
                        fullWidth
                        className="textField"
                        // style={{ width: "310px" }}
                        variant="outlined"
                        placeholder="Name"
                        value={this.state.name}
                        onChange={this.handleNameChange.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        Abbreviation
                      </label>
                      <TextField
                        type="text"
                        fullWidth
                        className="textField"
                        // style={{ width: "310px" }}
                        variant="outlined"
                        placeholder="Abbrevition"
                        value={this.state.abbrevition}
                        onChange={this.handleAbbrevitionChange.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Measure Type
                      </label>
                      <TextField
                        type="text"
                        fullWidth
                        className="textField"
                        // style={{ width: "310px" }}
                        variant="outlined"
                        placeholder="Measure Type"
                        value={this.state.measuretype}
                        onChange={this.handleMeasureTypeChange.bind(this)}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-center p-4">
                <div className="col-sm-12 text-center align-self-center">
                  <SaveButton btnName="Save" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton
                    btnName="Cancel"
                    onClick={(e) => this.handleUOMClose()}
                  />
                </div>
              </div>
            </DialogContent>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }
}
export default withRouter(UnitOfMeasurementList);
